import { MenuItem } from "../../Types/Layout/Sidebar";

export const MenuList: MenuItem[] = [
  {
    title: "Applications",
    lanClass: "lan-8",
    Items: [
      {
        title: "Users",
        icon: "user",
        type: "sub",
        active: false,
        roles: ["SUPER_ADMIN"], // Only super admins
        children: [
          {
            path: `/users/cards`,
            type: "link",
            title: "Users",
            roles: ["SUPER_ADMIN"],
          },
          {
            path: `/users/add`,
            type: "link",
            title: "Add User",
            roles: ["SUPER_ADMIN"],
          },
        ],
      },
      {
        title: "Authors",
        icon: "author",
        type: "sub",
        active: false,
        roles: ["ADMIN", "SUPER_ADMIN"],
        children: [
          {
            path: `/authors/cards`,
            type: "link",
            title: "Authors Profile",
            roles: ["ADMIN", "SUPER_ADMIN"],
          },
          {
            path: `/authors/add`,
            type: "link",
            title: "Add Author",
            roles: ["ADMIN", "SUPER_ADMIN"],
          },
        ],
      },
      {
        title: "Blog",
        icon: "blog",
        type: "sub",
        active: false,
        roles: ["ADMIN", "SUPER_ADMIN"],
        children: [
          {
            path: `/blogs/add`,
            type: "link",
            title: "Add Blogs",
            roles: ["ADMIN", "SUPER_ADMIN"],
          },
          {
            path: `/blogs/cards`,
            type: "link",
            title: "Blogs",
            roles: ["ADMIN", "SUPER_ADMIN"],
          },
        ],
      },
      {
        path: `/update-profile`,
        icon: "update-profile",
        title: "Update Profile",
        type: "link",
        roles: ["ADMIN", "SUPER_ADMIN"], // All roles can access
      },
    ],
  },
];
